import { Css, px, useTestIds } from "@homebound/beam";
import { getStage } from "src/context";

export function LocalProdWarning() {
  const localProdWarningId = useTestIds({}, "localProdWarning");
  const stage = getStage();

  if (stage !== "local-prod") {
    console.error(
      "The LocalProdWarning component was instantiated outside the local-prod environment. This should not happen! Please debug where this component is rendered.",
    );
    return null;
  }

  return (
    <div css={Css.bgRed100.fs0.w100.sticky.z999.h(px(48)).df.aic.mt2.$} {...localProdWarningId}>
      <div css={Css.mx3.$}>
        Please sign in at{" "}
        <a href={`https://blueprint.homebound.com/signIn`} {...localProdWarningId.link}>
          blueprint.homebound.com
        </a>{" "}
        then reload this page to pick up your auth token.
      </div>
    </div>
  );
}
